export const EDIT = 'checkout/contacts/EDIT';
export const edit = (path: string, value: any) => ({
  type: EDIT,
  payload: value,
  path,
});
